import React from 'react'

const categories = [
  {
    id: 1,
    title: 'Security',
    icon: 'ri-shield-keyhole-line',
    skills: [
      { name: 'Security Compliance', level: 85 },
      { name: 'Web Security', level: 88 },
      { name: 'Cloud Security', level: 80 },
      { name: 'Network Security', level: 70 },
      { name: 'AI Security', level: 80 },
    ],
  },
  {
    id: 2,
    title: 'QA & Automation',
    icon: 'ri-bug-line',
    skills: [
      { name: 'Robot Framework', level: 80 },
      { name: 'Python', level: 90 },
      { name: 'Playwright', level: 70 },
      { name: 'TypeScript', level: 70 },
      { name: 'XCUITest', level: 50 },
      { name: 'Swift', level: 50 },

    ],
  },
  {
    id: 3,
    title: 'Dev & DevOps',
    icon: 'ri-code-s-slash-line',
    skills: [
      { name: 'JavaScript / React', level: 80 },
      { name: 'Docker', level: 80 },
      { name: 'Azure', level: 70 },
      { name: 'CI/CD', level: 85 },
      { name: 'AWS', level: 80 },
    ],
  },
]

export default function TechStack() {
  return (
    <div className="py-24">
      <div className="text-center mb-12">
        <p className="section-label">{"// skills"}</p>
        <h2 className="text-[1.5rem] sm:text-[1.75rem] font-bold text-title mb-2">Tech Stack</h2>
        <p className="text-sm text-muted">The tools and technologies I work with daily.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
        {categories.map(({ id, title, icon, skills }) => (
          <div key={id} className="card p-6">
            <div className="flex items-center gap-2.5 mb-6">
              <i className={`${icon} text-lg text-accent`}></i>
              <h3 className="font-bold text-title text-[0.938rem]">{title}</h3>
            </div>

            <div className="flex flex-col gap-4">
              {skills.map(({ name, level }) => (
                <div key={name}>
                  <div className="flex items-center justify-between mb-1.5">
                    <span className="font-mono text-[0.75rem] text-muted">{name}</span>
                    <span className="font-mono text-[0.7rem] text-subtle">{level}%</span>
                  </div>
                  <div className="h-[3px] w-full rounded-full bg-surface">
                    <div
                      className="h-full rounded-full"
                      style={{
                        width: `${level}%`,
                        background: 'linear-gradient(to right, var(--accent), var(--subtle))',
                      }}
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
